import { passwordConstants } from "./types";
import {
  resetPassword,
  forgotPassword,
  resetPasswordWithSms,
  sendSmsForgotPasswordWithOTP,
} from "../../../services/login.service";
import { beginLogout } from "../login/actions";
import { alertActions, loading } from "../alert/actions";

const endError = (error) => {
  return (dispatch) => {
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: passwordConstants.RESET_PASSWORD_FAILURE,
        error,
      });
    }
  };
};

const resetPasswords = (oldPassword, newPassword) => {
  return (dispatch) => {
    // dispatch(request("resetPassword"));
    resetPassword(oldPassword, newPassword).then(
      (response) => {
        if (response.success) {
          dispatch(alertActions.success(response.message));
        } else {
          dispatch(alertActions.showError(response.message));
        }
      },
      (error) => {
        dispatch(endError(error));
      }
    );
  };
  function request(response) {
    return {
      type: passwordConstants.RESET_PASSWORD_REQUEST,
      payload: { response },
    };
  }
  function success(response) {
    return {
      type: passwordConstants.RESET_PASSWORD_SUCCESS,
      payload: { response },
    };
  }
};

const resetPasswordsWitSms = (data) => {
  return (dispatch) => {
    dispatch(request());
    resetPasswordWithSms(data).then(
      (response) => {
        if (response.success) {
          dispatch(success(response));
        } else {
           dispatch(alertActions.showError(response.message));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request() {
    return {
      type: passwordConstants.RESET_PASSWORD_REQUEST,
    };
  }
  function success(response) {
    return {
      type: passwordConstants.RESET_PASSWORD_SUCCESS,
      payload: { response },
    };
  }
  function failure() {
    return { type: passwordConstants.RESET_PASSWORD_FAILURE };
  }
};

const sendSmsForgotPassword = (data) => {
  return (dispatch) => {
    dispatch(request("sendSmsForgotPassword"));
    sendSmsForgotPasswordWithOTP(data).then(
      (response) => {
        if (response?.data?.code === 2) {
          dispatch(success(response, Date.now()));
        } else if (response?.data?.code === 66) {
          dispatch(failure());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response.data.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        } else
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response.data.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: passwordConstants.SENDSMS_FORGOT_PASSWORD_REQUEST,
      payload: { response },
    };
  }
  function success(response, countDate) {
    return {
      type: passwordConstants.SENDSMS_FORGOT_PASSWORD_SUCCESS,
      payload: { response, countDate },
    };
  }
  function failure(error) {
    return { type: passwordConstants.SENDSMS_FORGOT_PASSWORD_FAILURE, error };
  }
};

const forgotPasswords = (data) => {
  return (dispatch) => {
    dispatch(request("forgotPassword"));
    dispatch(loading.showLoading());
    forgotPassword(data).then(
      (response) => {
        if (response?.data?.code === 2) {
          dispatch(loading.hideLoading());
          dispatch(success(response, data.kimlikNo, Date.now()));
        } else {
          dispatch(loading.hideLoading());
          dispatch(
            alertActions.showError(
              response?.data?.return !== null
                ? response?.data?.return
                : "Beklenmeyen bir hata oluştu."
            )
          );
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(response) {
    return {
      type: passwordConstants.FORGOT_PASSWORD_REQUEST,
      payload: { response },
    };
  }
  function success(response, kimlikNo, countDate) {
    return {
      type: passwordConstants.FORGOT_PASSWORD_SUCCESS,
      payload: { response, kimlikNo, countDate },
    };
  }
  function failure(error) {
    return { type: passwordConstants.FORGOT_PASSWORD_FAILURE, error };
  }
};

const hideSmsModal = () => {
  return { type: passwordConstants.HIDE_SMS_MODAL };
};

export {
  resetPasswords,
  resetPasswordsWitSms,
  sendSmsForgotPassword,
  forgotPasswords,
  hideSmsModal,
};
